import { EntryType } from '../../constants/entry-type';

export type EmailEntryType = 'abentry' | 'lead';
export type AbEntryType = 'individual' | 'contact' | 'company';

export type EmailPosition =
  'to' | 'cc' | 'bcc' | 'from' | 'saveOnly' | 'remove';

export interface OutlookEmail {
  id?: string;
  emailAddress: string;
  displayName: string;
  type?: EmailEntryType;
  abentryType?: AbEntryType;
  emailSaved?: boolean;
  emailKey?: string;
  isNewEntry?: boolean;
  position?: EmailPosition;
  localId?: string;
  parentKey?: string;
  tag?: string;
}

export interface OutlookSaveEmail {
  othersInMaximizer: OutlookEmail[];
  inMaximizer: OutlookEmail[];
  opportunities: string[];
  cases: string[];
}

export type OutlookEmailDetail =
  | {
      subject: string;
      type: EntryType;
      key: string;
      abentryType?: AbEntryType;
    }
  | {
      subject: string;
      entry: OutlookEmail[];
    };

export interface OutlookEmailDetailEvent {
  id: string;
  type: EntryType;
}

export interface OutlookEmailCreationResult {
  parentKey: string;
  documentId: string;
}

export interface OutlookParentFolder {
  id: string;
  displayName: string;
  parentFolderId: string;
  childFolderCount: number;
  unreadItemCount: number;
  totalItemCount: number;
  sizeInBytes: number;
  isHidden: boolean;
}

export enum OutlookFolderName {
  Archive = 'Archive',
  Drafts = 'Drafts',
  DeletedItems = 'Deleted Items',
  Inbox = 'Inbox',
  Outbox = 'Outbox',
  SentItems = 'Sent Items',
}
